import { createQueryClient } from '@mint-lib/query-client';

import { MintAdminServiceLocatorAbstractFactoryContext } from '../types.js';

export async function queryClientFactory(
  ctx: MintAdminServiceLocatorAbstractFactoryContext,
) {
  const queryClient = createQueryClient();
  ctx.on('auth', 'logout', () => queryClient.clear());

  return queryClient;
}
